// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'c2413ed7fd6f1d7e3d56234cdb632bce2dd135ad';
export const BUILD_NUMBER = '213';
export const BUILD_TIMESTAMP = '2026-08-03T10:27:08.832Z';
